export const feedbackActionTypes = {
    STORE_FEEDBACK_LIST: 'STORE_FEEDBACK_LIST',
    STORE_MY_FEEDBACK: 'STORE_MY_FEEDBACK',
    UPVOTE_STARTED: 'UPVOTE_STARTED',
    STORE_UPVOTE_RESULT: 'STORE_UPVOTE_RESULT',
    UPVOTE_FAILED: 'UPVOTE_FAILED',
} as const;
